import separator from "../assets/img/underline.svg";

export default function Header() {
  return (
    <div className="header">
      <div className="title">
        <h1>Portail <span className="connect">Connect</span></h1>
        <img className="separator" src={separator} alt="" />
      </div>
    </div>
  );
}
